import React from 'react';

import { IAssigneeOptionsList, useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { Select } from 'components/DesignSystem/Select';
import { OptionsWithAssignee } from 'components/DesignSystem/Select/components/OptionsWithAssignee/OptionsWithAssignee';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AssigneeSelect = React.forwardRef<any, any>(({ ...rest }, ref) => {
    const { options } = useAssigneeOptionsList();
    return (
        <Select<IAssigneeOptionsList>
            {...rest}
            options={options}
            components={{
                Option: OptionsWithAssignee,
            }}
        />
    );
});
